import {AxiosResponse} from 'axios';
import {saveAs} from 'file-saver';
import {v4 as uuid} from 'uuid';
import contentStudioInstance from '@/utils/axiosContentStudio';

export const downloadAssetsProcess = async (
  assetIds: string[],
  analyticsInteractionID: string,
  analyticsLocation: string,
  processEventHandlers: {
    started: (params: any) => void;
    ended: (params: any) => void;
  }
) => {
  const {started, ended} = processEventHandlers;
  const processID = uuid();
  assetIds.forEach((assetId: string) => {
    started({
      endpoint: '/api/v1/assets/download-zip',
      process_id: processID,
      process_name: 'download',
      original_id: assetId, // TODO: replace with original_id
      interaction_id: analyticsInteractionID,
      asset_id: assetId,
      source: analyticsLocation,
    });
  });
  let result = '';
  let errorMessage = '';
  try {
    const response = await contentStudioInstance.post(
      '/api/v1/assets/download-zip',
      assetIds,
      {
        responseType: 'blob',
      }
    );
    downloadAssets(response, 'assets.zip');
    result = 'success';
    errorMessage = '';
  } catch (err) {
    result = 'failure';
    errorMessage = err instanceof Error ? err.message : String(err);
  } finally {
    assetIds.forEach((assetId: string) => {
      ended({
        endpoint: '/api/v1/assets/download-zip',
        outcome_id: assetId,
        original_id: assetId, // TODO: replace with original_id
        result,
        process_id: processID,
        process_name: 'download',
        error: errorMessage,
      });
    });
  }
};

export const downloadAssets = async (
  response: AxiosResponse,
  fileName: string
) => {
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  saveAs(blob, fileName);
};
